import axios from "axios";
import { Client } from "client-sdk/src";
import { GetAllTicketsRequestBuilder } from "client-sdk/src/helpical/categories"
import handleError from "../../utils/handleError";

const token = localStorage.getItem("token");

export async function getAllTickets(params?: object) {
  try {
    const getTickets = new GetAllTicketsRequestBuilder()
    .params(params)
      .build();
    const client = new Client(token as string);
    const response = client.execute(
     getTickets,
    );
    return response;
  } catch (error) {
    return handleError(error.response);
  }
}
export default getAllTickets;
